import styles from "./GroupItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import Link from "shared/Link";
import Button from "shared/Button";

import { Auth } from "shared/@auth/Auth";

/**
 *
 * Displays information about a group in a group list.
 *
 */

export function GroupItem({ groupInfo, empty, onClick }) {
  const { hasPermission } = Auth.useContainer();

  return (
    <div className={classNames(styles.container, empty && styles.empty)}>
      {/* <div
      className={classNames(
        styles.container,
        empty ? styles.empty : "undefined"
      )}
    > */}
      <div className={styles.item}>
        {groupInfo.iboNumber !== 0 && (
          <Link to={`/membership/lookup/ibo/${groupInfo.iboNumber}`}>
            {groupInfo.iboNumber}
          </Link>
        )}
      </div>
      <div className={styles.item}>{groupInfo.organization}</div>
      <div className={styles.item}>{groupInfo.groupName}</div>

      <div className={styles.item}>
        {groupInfo.pinLevel === 0 ? "NON-LOS" : "LOS"}
      </div>

      {hasPermission("developer.*") && (
        <div className={styles.item}>
          <Button className={styles.detailsBtn} onClick={onClick} size="small">
            Details
          </Button>
        </div>
      )}
      {/* <div className={styles.item}>{groupInfo.groupId}</div> */}

      {/* {!empty && (
        <>
          <div className={styles.item}>{groupInfo.memberCount}</div>

          <div className={styles.item}>
            <Link to="/dreamstream/group">
              <button className={styles.button} onClick={onClick}>
                Details
              </button>
            </Link>
          </div>
        </>
      )} */}
    </div>
  );
}

GroupItem.propTypes = {
  groupInfo: PropTypes.object,
  empty: PropTypes.bool,
  onClick: PropTypes.func,
};
